import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { LinkContext } from "../../LinkProvider";
import AnimatedCTA from "../AnimatedCTA";

import ellipseSalmon  from "../../img/home/trusted-ellipse-salmon.svg";
import ellipseDark    from "../../img/home/trusted-ellipse-dark.svg";
import ellipseLight   from "../../img/home/trusted-ellipse-light.svg";
import ellipseDark2   from "../../img/home/trusted-ellipse-dark2.svg";
import iconCert       from "../../img/home/trusted-icon-certificate.svg";
import iconPin        from "../../img/home/trusted-icon-pin.svg";
import iconTrophy     from "../../img/home/trusted-icon-trophy.svg";
import globeA         from "../../img/home/trusted-icon-globe-a.svg";
import globeB         from "../../img/home/trusted-icon-globe-b.svg";
import globeC         from "../../img/home/trusted-icon-globe-c.svg";
import globeD         from "../../img/home/trusted-icon-globe-d.svg";
import globeE         from "../../img/home/trusted-icon-globe-e.svg";
import globeF         from "../../img/home/trusted-icon-globe-f.svg";

const PeopleIcon = () => (
  <div className="relative size-[22px] xl:size-[30px] overflow-hidden shrink-0">
    <div className="absolute inset-[53.38%_0_7.59%_77.83%]"><img src={globeA} alt="" className="absolute inset-0 w-full h-full" /></div>
    <div className="absolute inset-[53.38%_77.83%_7.59%_0]"><img src={globeB} alt="" className="absolute inset-0 w-full h-full" /></div>
    <div className="absolute inset-[45.86%_26.72%_7.59%_26.73%]"><img src={globeC} alt="" className="absolute inset-0 w-full h-full" /></div>
    <div className="absolute inset-[7.59%_32.64%_57.69%_32.64%]"><img src={globeD} alt="" className="absolute inset-0 w-full h-full" /></div>
    <div className="absolute inset-[23.77%_67.5%_50.27%_6.53%]"><img src={globeE} alt="" className="absolute inset-0 w-full h-full" /></div>
    <div className="absolute inset-[23.77%_6.53%_50.27%_67.5%]"><img src={globeF} alt="" className="absolute inset-0 w-full h-full" /></div>
  </div>
);

function TrustedAcross() {
  const { t } = useTranslation();
  const { link } = useContext(LinkContext);

  return (
    <section className="mt">
      <div className="glcontainer flex flex-col gap-[20px]">

        {/* Row 1: title/CTA + Strong card */}
        <div className="flex flex-col xl:flex-row gap-[20px] items-start">

          {/* Left: title + desc + CTA */}
          <div className="flex-1 flex flex-col gap-[24px] xl:gap-0 xl:relative xl:h-[358px]">
            <h2 className="font-48-28 xl:absolute xl:top-0 xl:left-0 xl:w-[660px]">
              {t("home.trusted.title")}
            </h2>
            <p className="font-18-14 xl:absolute xl:top-[116px] xl:left-[310px] xl:w-[497px]">
              {t("home.trusted.desc")}
            </p>
            <div className="flex items-center xl:absolute xl:top-[241px] xl:left-0">
              <AnimatedCTA href={link} mobile>
                {t("btn.start-trading")}
              </AnimatedCTA>
            </div>
          </div>

          {/* Strong card */}
          <div className="relative rounded-[20px] overflow-hidden bg-[#ffe6dc] w-full xl:w-[393px] shrink-0 h-[140px] xl:h-[358px]">
            <div className="absolute top-[23px] left-[30px] xl:top-[93px] xl:left-[20px] size-[60px] xl:size-[80px]">
              <img src={ellipseSalmon} alt="" className="absolute inset-0 w-full h-full" />
            </div>
            <div className="absolute top-[42px] left-[49px] xl:top-[118px] xl:left-[45px] size-[22px] xl:size-[30px]">
              <img src={iconCert} alt="" className="w-full h-full object-contain" />
            </div>
            <div className="absolute top-[34px] left-[84px] xl:top-[124px] xl:left-[87px] flex flex-col gap-[4px] tracking-[-0.4px]">
              <span className="font-['Montserrat'] font-extrabold text-[40px] xl:text-[64px] text-[#020202] leading-[1.2]">
                {t("home.trusted.stat1.value")}
              </span>
              <span className="font-['Montserrat'] font-medium text-[16px] xl:text-[24px] text-[#020202] leading-[1.2]">
                {t("home.trusted.stat1.label")}
              </span>
            </div>
          </div>
        </div>

        {/* Row 2: 2.5M+ full width on mobile, then 120+/15+ side-by-side */}
        <div className="flex flex-col xl:flex-row gap-[20px] items-stretch">

          {/* 2.5M+ Traders — dark */}
          <div className="relative rounded-[20px] overflow-hidden bg-[#020202] xl:flex-[497] h-[140px] xl:h-[358px]">
            <div className="absolute top-[10px] left-[30px] xl:top-[40px] xl:left-[20px] size-[60px] xl:size-[80px]">
              <img src={ellipseDark} alt="" className="absolute inset-0 w-full h-full" />
            </div>
            <div className="absolute top-[29px] left-[49px] xl:top-[65px] xl:left-[45px]">
              <PeopleIcon />
            </div>
            <div className="absolute top-[19px] left-[84px] xl:top-[60px] xl:left-[60px] flex flex-col gap-[4px] tracking-[-0.4px]">
              <span className="font-['Montserrat'] font-extrabold text-[64px] xl:text-[120px] text-white leading-[1.2]">
                {t("home.trusted.stat2.value")}
              </span>
              <span className="font-['Montserrat'] font-medium text-[16px] xl:text-[24px] text-white leading-[1.2]">
                {t("home.trusted.stat2.label")}
              </span>
            </div>
          </div>

          {/* 120+ and 15+ — side-by-side on mobile, inline on desktop */}
          <div className="flex flex-row gap-[20px] xl:contents">

            {/* 120+ Countries — light gray */}
            <div className="relative rounded-[20px] overflow-hidden bg-[#ededed] flex-1 xl:flex-[393] h-[205px] xl:h-[358px]">
              <div className="absolute top-[27px] left-[10px] xl:top-[40px] xl:left-[20px] size-[60px] xl:size-[80px]">
                <img src={ellipseLight} alt="" className="absolute inset-0 w-full h-full" />
              </div>
              <div className="absolute top-[46px] left-[29px] xl:top-[65px] xl:left-[45px] size-[22px] xl:size-[30px]">
                <img src={iconPin} alt="" className="w-full h-full object-contain" />
              </div>
              <div className="absolute top-[71px] left-[11px] xl:top-[72px] xl:left-[60px] flex flex-col gap-[4px] tracking-[-0.4px]">
                <span className="font-['Montserrat'] font-extrabold text-[48px] xl:text-[110px] text-[#020202] leading-[1.2]">
                  {t("home.trusted.stat3.value")}
                </span>
                <span className="font-['Montserrat'] font-medium text-[16px] xl:text-[24px] text-[#020202] leading-[1.2]">
                  {t("home.trusted.stat3.label")}
                </span>
              </div>
            </div>

            {/* 15+ Awards — orange */}
            <div className="relative rounded-[20px] overflow-hidden bg-[#ee5414] flex-1 xl:flex-[290] h-[205px] xl:h-[358px]">
              <div className="absolute top-[27px] left-[19px] xl:top-[40px] xl:left-[20px] size-[60px] xl:size-[80px]">
                <img src={ellipseDark2} alt="" className="absolute inset-0 w-full h-full" />
              </div>
              <div className="absolute top-[46px] left-[38px] xl:top-[65px] xl:left-[45px] size-[22px] xl:size-[30px]">
                <img src={iconTrophy} alt="" className="w-full h-full object-contain" />
              </div>
              <div className="absolute top-[71px] left-[19px] right-[19px] xl:top-[72px] xl:left-[60px] xl:right-[20px] flex flex-col gap-[4px] tracking-[-0.4px]">
                <span className="font-['Montserrat'] font-extrabold text-[48px] xl:text-[110px] text-white leading-[1.2]">
                  {t("home.trusted.stat4.value")}
                </span>
                <span className="font-['Montserrat'] font-medium text-[16px] xl:text-[24px] text-white leading-[1.2] break-words hyphens-auto">
                  {t("home.trusted.stat4.label")}
                </span>
              </div>
            </div>

          </div>
        </div>

      </div>
    </section>
  );
}

export default TrustedAcross;
